import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackAndNavigate } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  tone?: 'primary' | 'light';
}
export function CtaButton({
  children,
  href = '#oferta',
  size = 'lg',
  tone = 'primary'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'w-full max-w-md px-6 py-4 text-[13px] sm:w-auto sm:max-w-none sm:px-12 sm:py-5 sm:text-base' : 'w-full max-w-sm px-6 py-4 text-xs sm:w-auto sm:max-w-none sm:px-7 sm:text-sm';
  const tones = tone === 'primary' ? 'bg-brand text-white hover:bg-brand-dark shadow-lg shadow-brand/30' : 'bg-stone-50 text-stone-900 hover:bg-white shadow-lg shadow-stone-900/10';
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (href.startsWith('http')) {
      trackAndNavigate(event, href, 'InitiateCheckout', {
        content_name: 'MegaPack Contabilidad Lista',
        content_ids: ['megapack-contabilidad-lista'],
        content_type: 'product',
        value: 19990,
        currency: 'ARS'
      });
    }
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex items-center justify-center gap-2 rounded-full sm:gap-3 font-semibold uppercase tracking-[0.12em] transition-[transform,background-color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-stone-900 ${sizing} ${tones}`} data-id="element-57" data-mp="39zssdqvfwv4y">
      <span className="text-center leading-tight" data-id="element-58" data-mp="3swapyowyzp94">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:translate-x-1" aria-hidden="true" data-id="element-59" data-mp="1ifvllfgd8m4" />
    </a>;
}